import { create } from 'zustand';
import {
  getDestinations,
  addDestinationApi,
  removeDestinationApi,
  type Destination,
} from '@/lib/api';

export type { Destination };

interface DestinationState {
  destinations: Destination[];
  isLoading: boolean;
  error: string | null;

  fetchDestinations: () => Promise<void>;
  addDestination: (label: string, address: string, lat: number, lng: number) => Promise<void>;
  removeDestination: (id: string) => Promise<void>;
}

export const useDestinationStore = create<DestinationState>((set) => ({
  destinations: [],
  isLoading: false,
  error: null,

  fetchDestinations: async () => {
    set({ isLoading: true, error: null });
    try {
      const destinations = await getDestinations();
      set({ destinations: destinations ?? [], isLoading: false });
    } catch (error) {
      set({ error: (error as Error).message, isLoading: false });
    }
  },

  addDestination: async (label, address, lat, lng) => {
    set({ isLoading: true, error: null });
    try {
      const dest = await addDestinationApi(label, address, lat, lng);
      set((state) => ({
        destinations: [...state.destinations, dest],
        isLoading: false,
      }));
    } catch (error) {
      set({ error: (error as Error).message, isLoading: false });
    }
  },

  removeDestination: async (id) => {
    try {
      await removeDestinationApi(id);
      set((state) => ({
        destinations: state.destinations.filter((d) => d.id !== id),
      }));
    } catch (error) {
      set({ error: (error as Error).message });
    }
  },
}));
